<div class="recording-page">

  <!-- LEFT SIDE: LIST & SEARCH -->
  <div class="recording-list">

    <div class="page-header">
      <div>
        <h2 class="page-title">User Recordings</h2>
        <p class="page-subtitle">Inspect and review recorded punch video rounds</p>
      </div>

      <div class="total-count-badge" *ngIf="totalRecords">
        <mat-icon>videocam</mat-icon>
        <span>{{ totalRecords }} Recordings</span>
      </div>
    </div>

    <!-- Search Filter Bar -->
    <div class="search-filter-container">
      <mat-form-field appearance="outline" class="w-100 search-field" subscriptSizing="dynamic">
        <mat-icon matPrefix>search</mat-icon>
        <input 
          matInput 
          placeholder="Filter by video title or athlete name..." 
          [(ngModel)]="searchTerm" 
          (input)="onSearchInput(searchTerm)" />
        <button 
          *ngIf="searchTerm" 
          mat-icon-button 
          matSuffix 
          (click)="clearSearch()" 
          class="clear-btn" 
          aria-label="Clear search">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-state">
      <mat-spinner diameter="32"></mat-spinner>
      <span>Loading video sessions...</span>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoading && filteredRecordings.length === 0" class="empty-list-state">
      <mat-icon>videocam_off</mat-icon>
      <h3>No Recordings Found</h3>
      <p *ngIf="searchTerm">No workout sessions match "{{ searchTerm }}".</p>
      <p *ngIf="!searchTerm">No marketing video sessions recorded yet.</p>
      <button *ngIf="searchTerm" mat-stroked-button (click)="clearSearch()" class="reset-btn">
        Clear Filter
      </button>
    </div>

    <!-- Recordings Card List -->
    <div class="cards-scroll-track" *ngIf="!isLoading && filteredRecordings.length > 0">
      <div 
        class="recording-card"
        *ngFor="let recording of filteredRecordings"
        (click)="selectRecording(recording)"
        [class.selected]="selectedRecording?.id === recording.id">

        <div class="video-thumb">
          <video [src]="recording.videoUrl" preload="metadata"></video>
          <div class="play-icon">
            <mat-icon>play_arrow</mat-icon>
          </div>
        </div>

        <div class="recording-info">
          <h3 class="recording-title" [title]="recording.title">{{ recording.title || 'Workout Session' }}</h3>

          <p class="user-name">
            <mat-icon>person</mat-icon>
            <span>{{ recording.profile?.username || recording.profile?.fullName || 'Athlete' }}</span>
          </p>

          <div class="recording-meta">
            <span class="meta-item">
              <mat-icon>timer</mat-icon>
              {{ formatDuration(recording.duration) }}
            </span>

            <span class="meta-item punches">
              <mat-icon>sports_mma</mat-icon>
              {{ recording.punchCount || 0 }} punches
            </span>

            <span class="meta-item" *ngIf="recording.createdAt">
              <mat-icon>calendar_today</mat-icon>
              {{ recording.createdAt | date: 'dd MMM yyyy' }}
            </span>
          </div>
        </div>

        <mat-icon class="arrow">chevron_right</mat-icon>
      </div>
    </div>

    <!-- Paginator -->
    <mat-paginator
      [length]="totalRecords"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="pageSizeOptions"
      (page)="onPageChange($event)">
    </mat-paginator>

  </div>

  <!-- RIGHT SIDE: VIDEO PLAYER PREVIEW -->
  <div class="video-preview">

    <div *ngIf="!selectedRecording" class="no-video">
      <mat-icon>smart_display</mat-icon>
      <h3>Select a Recording</h3>
      <p>Click any recording card from the left panel to play the video session</p>
    </div>

    <div *ngIf="selectedRecording" class="player-wrapper">
      <div class="player-header">
        <div class="player-meta-group">
          <h2 class="player-title">{{ selectedRecording.title || 'Workout Video Session' }}</h2>
          <div class="player-user-chip">
            <mat-icon>person</mat-icon>
            <span>{{ selectedRecording.profile?.username || selectedRecording.profile?.fullName || 'Athlete' }}</span>
          </div>
        </div>
        <button mat-icon-button (click)="closeVideo()" class="close-player-btn" matTooltip="Close video">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="main-video-container">
        <video [src]="selectedRecording.videoUrl" controls autoplay class="video-element"></video>
      </div>

      <div class="video-details-grid">
        <div class="detail-box">
          <span class="detail-label">Duration</span>
          <strong class="detail-value">{{ formatDuration(selectedRecording.duration) }}</strong>
        </div>
        <div class="detail-box">
          <span class="detail-label">Total Punches</span>
          <strong class="detail-value highlight-punches">{{ selectedRecording.punchCount || 0 }}</strong>
        </div>
        <div class="detail-box" *ngIf="selectedRecording.createdAt">
          <span class="detail-label">Session Date</span>
          <strong class="detail-value">{{ selectedRecording.createdAt | date: 'dd MMM yyyy, hh:mm a' }}</strong>
        </div>
      </div>
    </div>

  </div>

</div>